
import { Placement } from '@post-office/placements-frontend/share-and-permissions-modal';
export default Placement;
